function initFFOCarousel() {

    setTimeout(function () { $(".FFOCarousel").removeClass("FFOCarousel--hide"); }, 8000);
 
}